import React from 'react';
import { Form, InputNumber, Button, Card, Typography, message as antdMessage } from 'antd';

const { Title } = Typography;

interface DeadlineFormProps {
  onDeadlineSet: (deadline: number | null) => void;
  currentDeadline: number | null;
  disabled: boolean;
}

const DeadlineForm: React.FC<DeadlineFormProps> = ({ onDeadlineSet, currentDeadline, disabled }) => {
  const [form] = Form.useForm();

  const onFinish = (values: any) => {
    const newDeadline = values.deadlineDays === undefined || values.deadlineDays === null ? null : Number(values.deadlineDays);
    if (newDeadline !== null && newDeadline < 0) {
        antdMessage.error('Deadline must be a non-negative number.');
        return;
    }
    onDeadlineSet(newDeadline);
    antdMessage.success(newDeadline !== null ? `Deadline set to ${newDeadline} days.` : 'Deadline cleared.');
  };

  React.useEffect(() => {
    form.setFieldsValue({ deadlineDays: currentDeadline });
  }, [currentDeadline, form]);


  return (
    <Card style={{ marginTop: 24 }}>
      <Title level={4}>Deadline setzen</Title>
      <p>Optional: Setzen Sie eine Deadline in Tagen.</p>
      <Form form={form} layout="inline" onFinish={onFinish} initialValues={{ deadlineDays: currentDeadline }}>
        <Form.Item
          label="Deadline (Tage):"
          name="deadlineDays"
        >
          <InputNumber min={0} step={0.01} placeholder="Deadline in Tagen" disabled={disabled} style={{width: '180px'}} />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" disabled={disabled}>
            Deadline setzen/löschen
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default DeadlineForm;